import { gql } from '@apollo/client';

export const DOWNLOAD_AUDIT_TRAIL = gql`
  query DownloadAuditTrail($input: AudiTrailsInput) {
    auditTrail: downloadAuditTrail(input: $input) {
      auditTrailFile
    }
  }
`;
